class Medianova {
  constructor() {
    this.timeout = null
    this.live = {
      token: null,
      url: "https://mn-nl.mncdn.com/wisiontv"
    }
    this.large = {
      token: null,
      url: "https://wisiontv-p.mncdn.com"
    }
  }
  async init(renew = false) {
    if (this.isInitialized() && !renew) return true
    if (this.timeout) this.timeout = clearTimeout(this.timeout)

    const expire = new Date().getTime() / 1000 + 3600
    const { tokenLarge, tokenLive } = await __.api.get.cdn({ driver: "medianova", expire: Math.round(expire) })

    this.large.token = tokenLarge
    this.live.token = tokenLive

    if (renew) {
      const currentSource = _$.splitUrl(__.media.player.src()),
        regex = new RegExp(this.live.url + "|" + this.large.url)
      if (regex.test(currentSource.initial)) __.media.play(__.media.source)
    }

    this.timeout = setTimeout(() => this.init(true), 3300 * 1000)

    return this.isInitialized()
  }
  async convert(url) {
    if (!(await this.init())) return false

    var ext = url.split(".").pop()
    if (["mp4", "ts", "mp3", "mkv"].indexOf(ext) >= 0) return `${this.large.url + url + this.large.token}`
    else return `${this.live.url + url + this.live.token}`
  }
  isInitialized() {
    return this.live.token && this.large.token
  }
}

export default new Medianova()
